import {CONTAINER_LAYOUT_TYPES, ITEM_LAYOUT_TYPES, COMPONENT_LAYOUT_TYPES} from '../defaultResponsiveLayoutDefinitions'

export const pageDefaultResponsiveLayout = {
    getLayout: () => ({
        COMPONENT_LAYOUT_TYPES: COMPONENT_LAYOUT_TYPES.HEIGHT_AUTO,
        CONTAINER_LAYOUT_TYPES: CONTAINER_LAYOUT_TYPES.MIN_MAX_SIZE,
        ITEM_LAYOUT_TYPES: ITEM_LAYOUT_TYPES.NO_ITEM_LAYOUT
    })
}
